import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Icon from "@components/icon";

import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import footerLinks from "../../../../../links/footerLinks";

import styles from "../MainMenuDropdown.scss";

const cx = classnames.bind(styles);

const FooterLink = ({ name, linkData, isBlack }) => {
  const data = linkData || footerLinks[name] || {};

  return (
    <a
      className={cx("footer-link", { "is-black": isBlack })}
      href={data.href}
      onClick={() => sendNavigationMetric(data.code)}
    >
      <Icon className={cx("footer-link-icon")} name={data.iconName} size="s" />
      <span className={cx("footer-label")}>
        {data.shortLabel || data.label}
      </span>
    </a>
  );
};

FooterLink.propTypes = {
  name: PropTypes.string,
  linkData: PropTypes.object,
  isBlack: PropTypes.bool,
};

export default FooterLink;
